import '@oriola-corporation/ui-components/lib/esm/style.css';
import { AuthContextProvider, Header } from '@oriola-corporation/ecom-portal-auth';

import { ClickCollect } from './components/ClickCollect/ClickCollect';
import { Info } from './components/Info/Info';
import { Services } from './components/Services/Services';
import { Support } from './components/Support';
import { AUTH_ENV } from './config';
import { PharmacyProvider } from './contexts/Pharmacy';

const App = () => {
  return (
    <>
      <AuthContextProvider env={AUTH_ENV}>
        <Header name="" link="/" />
        <PharmacyProvider>
          <div className="mx-auto my-5 flex max-w-[1200px] content-evenly justify-between">
            <div className="flex w-2/3 flex-col content-evenly">
              <Services />
            </div>
            <div className="flex w-2/5 flex-col">
              <Info />
              <ClickCollect />
              <Support />
            </div>
          </div>
        </PharmacyProvider>
      </AuthContextProvider>
    </>
  );
};

export default App;
